import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'

const JoinLogout = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: "",
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="flex_1 padding center-cont">
				<i className="icon icon_password_intro" />
				<h3 className="intro-tit mt_30">자동으로 로그아웃 되었습니다.</h3>
				<span className="intro-sub-tit mt_10">개인정보 보호를 위해<br />
					로그인 후 10분동안 서비스 이용이 없어<br />
					자동으로 로그아웃 되었습니다.</span>
			</div>
			<div className="flex-shrink_0 padding">
				<Button className="btn btn--big">다시 로그인하기</Button>
			</div>
		</div>
	)
}

export default JoinLogout